import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { aiReportTypes } from '../types';

import { axios } from '@/libraries/axios';
import {
  ExtractFnReturnType,
  MutationConfig,
  QueryConfig,
  queryClient,
} from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'update-page-report-prompt';

export const getPageReportPrompt: aiReportTypes.GetPrompt = (params) => {
  return axios.get('/page-reports/prompt', { params });
};

export const updatePageReportPrompt: aiReportTypes.UpdatePrompt = (params) => {
  return axios.put('/page-reports/prompt', params);
};

type GetFn = typeof getPageReportPrompt;
type UpdateFn = typeof updatePageReportPrompt;

export const useGetPageReportPrompt = ({
  promptKey,
  config = {},
}: {
  promptKey?: string;
  config?: QueryConfig<GetFn>;
}) => {
  return useQuery<ExtractFnReturnType<GetFn>>({
    ...config,
    queryKey: ['page-report-prompt', promptKey],
    queryFn: () => getPageReportPrompt({ key: promptKey }),
  });
};

export const useUpdatePageReportPrompt = ({
  config = {},
}: { config?: MutationConfig<UpdateFn> } = {}) => {
  return useMutation({
    ...config,
    mutationFn: updatePageReportPrompt,
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Сохраняем новую версию промта...');
      config.onMutate?.(...args);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['page-report-prompt']);
      queryClient.invalidateQueries(['page-report-types']);
      toasts.loadingToast.success(TOAST_ID, 'Создана новая версия промта');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error?: string }>, ...args) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      config.onError?.(error, ...args);
    },
  });
};
